/* eslint-disable */
import React, { useCallback, useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
const DraggableItem = ({ disabled, index, item, draggedItems, findItemIndex, isSelected, itemRenderer: ItemRendererComponent, onClick, containerId, isLocked, onChangeIndex, onDragStart, selectedItems, take, apply, }) => {
    const itemRef = useRef(null);
    const [startedDrag, setStartedDrag] = React.useState(false);
    const sortByIndex = (list) => list.sort((a, b) => findItemIndex(a) - findItemIndex(b));
    const isDraggedItem = React.useCallback(() => findItemIndex(item) !== -1, [draggedItems]);
    const classes = isSelected ? ["selected"] : [];
    const sortedSelected = React.useMemo(() => sortByIndex(selectedItems), [selectedItems]);
    const [{ isDraggingItem, draggedStyle }, drag, dragPreview] = useDrag({
        type: containerId,
        item: {
            index,
            items: isSelected ? sortedSelected : [item],
            containerId,
            take: (list) => sortedSelected.map((item) => take(item, list)),
        },
        end: () => {
            apply();
        },
        canDrag: () => !isLocked && !disabled,
        collect: (monitor) => {
            if (isDraggedItem() && !startedDrag) {
                onDragStart(sortedSelected);
                setStartedDrag(true);
            }
            if (isDraggedItem() && !classes.includes("dragging")) {
                classes.push("dragging");
            }
            return {
                isDraggingItem: monitor.isDragging(),
                draggedStyle: {
                    border: monitor.isDragging() && !isSelected && draggedItems.length === 0
                        ? "2px solid #A1A1AA"
                        : undefined,
                },
            };
        },
    }, [startedDrag, sortedSelected, isSelected]);
    const [, drop] = useDrop({
        accept: containerId,
        hover: (draggedItem, monitor) => {
            const { index: dragIndex, items, containerId: sourceContainerId, } = draggedItem;
            const hoverIndex = index;
            if (dragIndex === hoverIndex ||
                isLocked ||
                disabled ||
                monitor.isOver({ shallow: true })) {
                return;
            }
            const hoverBoundingRect = itemRef.current?.getBoundingClientRect();
            if (!hoverBoundingRect)
                return;
            const clientOffset = monitor.getClientOffset();
            if (!clientOffset)
                return;
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const hoverActualY = clientOffset.y - hoverBoundingRect.top;
            // if dragging down, continue only when hover is smaller than middle Y
            if (index < hoverIndex && hoverActualY < hoverMiddleY)
                return;
            // if dragging up, continue only when hover is bigger than middle Y
            if (index > hoverIndex && hoverActualY > hoverMiddleY)
                return;
            onChangeIndex(dragIndex, hoverIndex, sourceContainerId !== containerId, (list) => items.map((item) => take(item, list)));
            draggedItem.index = hoverIndex;
            if (sourceContainerId !== containerId) {
                draggedItem.containerId = containerId;
                draggedItem.take = (list) => take(items, list);
            }
        },
        drop(item, monitor) {
            setStartedDrag(false);
            return undefined;
        },
    });
    const setRef = useCallback((ref) => {
        itemRef.current = ref;
        drag(drop(ref));
    }, [drag, drop]);
    return (React.createElement("div", { key: item.id, ref: dragPreview },
        React.createElement("div", { style: draggedStyle, ref: setRef, onClick: onClick },
            React.createElement(ItemRendererComponent, { className: classes.join(" "), item: item }))));
};
export default DraggableItem;
